import React, { useState } from 'react';
import { withAdminWriteAccess } from 'contexts/adminAccess';
import AddIcon from '@material-ui/icons/Add';
import makeStyles from '@material-ui/core/styles/makeStyles';

import ActionButton from 'components/buttons/ActionButton';

import EditActionDialog from './EditActionDialog';

const useStyles = makeStyles((theme) => ({
  label: {
    width: '150px',
  },
}));

const AddActionButton = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <ActionButton startIcon={<AddIcon />} onClick={handleOpen} classes={{ label: classes.label }}>
        Add Action
      </ActionButton>
      {open && <EditActionDialog open={open} onClose={handleClose} />}
    </>
  );
};

export default withAdminWriteAccess(AddActionButton);
